import * as React from 'react'

import { css, Global, useTheme } from '@emotion/react'

import { DropShadows, dropShadows } from '../theme/dropShadows'

export default () => {
  const theme = useTheme()
  return (
    <Global
      styles={css`
        :root {
          ${Object.keys(dropShadows).map(key => {
            const dropShadow = key as DropShadows
            return `--mooncake-dropShadow-${key}: ${theme.dropShadows[dropShadow]};`
          })}
        }
      `}
    />
  )
}
